import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AssignmentRoutingModule } from './assignment-routing.module';
import { ListComponent } from './list/list.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ListForStudentComponent } from './list-for-student/list-for-student.component';
import { ProjectsComponent } from './projects/projects.component';
import { FaqsComponent } from './faqs/faqs.component';
import { ResourcesComponent } from './resources/resources.component';


@NgModule({
  declarations: [
    ListComponent,
    ListForStudentComponent,
    ProjectsComponent,
    FaqsComponent,
    ResourcesComponent
  ],
  imports: [
    CommonModule,
    AssignmentRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgxDatatableModule,
    PipeModule,
    NgbModule,
    NgSelectModule,
    NgxSpinnerModule
  ]
})
export class AssignmentModule { }
